export default {
    sysPerf: {
        netmet: 'NetMet',
        systemPerformance: 'System Performance',
        systemMetrics: 'Metrics',
        systemOverview: 'Overview',
        streamer: 'Streamer',
        ingestion: 'Ingestion',
        processing: 'Processing',
        mongoDB: 'Database',
        ui: 'NetMet UI',
        kafka: 'Data Bus',
        rni: 'RNI',
        rniHosts: 'RNI Hosts',
        kbPerSec: 'kB/Sec',
        allCustomers: 'All Customers',
        customers: 'Customers',
        msgsPerSecond: 'msgs/sec',
        writesPerSecond: 'writes/sec',
        lag: 'lag',
        sysdb: {
            topicRatesTitle: 'Topic I/O',
            topicRatesGraphLabel: 'Bytes/Sec',
            topicInputTitle: 'Topic Input',
            topicInputGraphLabel: 'Bytes/Sec',
            topicOutputTitle: 'Topic Output',
            topicOutputGraphLabel: 'Bytes/Sec',
            topicLagTitle: 'Topic Consumer Max Lag',
            topicLagGraphLabel: 'Count',
            mongoTitle: 'Mongo I/O',
            mongoGraphLabel: 'Bytes/Sec',
            systemDataRatesTitle: 'System Data Rates',
            customerInputTitle: 'Customer Input',
            customerInputGraphLabel: 'Msgs/Sec',
            customerMsgsInPerSec: 'Customer Input',
            graphError: 'Error retrieving graph data for {graphName}',
            mongoRates: 'Mongo I/O',
            mongoBytesInPerSec: 'Mongo Writes',
            mongoBytesOutPerSec: 'Mongo Reads',
            infoTooltip: 'The lag metrics on this page are snapshot values.  The other metrics are derived from the data in the last 5 minute interval.'
        },
        status: {
            ok: 'Good Performance',
            warning: 'Performance Warning',
            alert: 'Performance Alert'
        },
        topicMetrics: {
            readTopic: 'Read Topic',
            writeTopic: 'Write Topic',
            kbPerSecond: 'kB/Sec',
            msgsPerSecond: 'Msgs/Sec',
            lag: 'Lag'
        },
        serviceMetrics: {
            service: 'Service',
            requestsPerSecond: 'Reqs/Sec',
            secondsPerRequest: 'Secs/Req'
        },
        mongoMetrics: {
            readRate: 'Read Rate (kB/Sec)',
            writeRate: 'Write Rate (kB/Sec)',
            upTime: 'Last Started'
        },
        getSystemMetricsError: 'Error retrieving system metrics',
        getSystemOverviewError: 'Error retrieving system overview metrics',
        getSystemOverviewAllError: 'Error retrieving system overview metrics',
        dateRange: {
            last24Hours: "Showing last 24 hours of data",
            last7Days: "Showing last 7 days of data",
            last30Days: "Showing last 30 days of data",
            custom: "Showing data from {from} to {to}",
        },
        refreshRate: {
            'off': 'Off',
            '5m': '5 Mins',
            '10m': '10 Mins',
            '30m': '30 Mins',
            '1h': '1 hour',
            '5h': '5 hours',
            '24h': '24 hours',
        },
        graphanaDashError: "Graphana dashboard could not be loaded"
    }
}
